import { Router, NavigationEnd } from '@angular/router';
import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-cartera-riesgo',
  templateUrl: './cartera-riesgo.component.html',
  styleUrls: ['./cartera-riesgo.component.scss']
})
export class CarteraRiesgoComponent{
  url = '';

  constructor(private loginService: LoginService,private router: Router) {
    router.events.subscribe((route) => {
      if(route instanceof NavigationEnd){
         this.url = route.url;
      }
   });
   }
  
  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
